<div class="title">
    <div class="row">
        <div class="col d-flex justify-content-end">
            <button type="button" class="action-btn" (click)="closeDialog()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <div class="row">
        <div class="col d-flex justify-content-center">
            <h2>Nume cetățean: {{citizen.name}}</h2>
        </div>
    </div>
</div>
<div class="container">
    <div class="info-card">
        <div class="info-header">
            <mat-icon>info</mat-icon>
            <span class="info-title">Info cetățean</span>
        </div>
        <div class="info-content">
            <div class="info-row">
                <label>Nume:</label>
                <span>{{citizen.nume}}</span>
            </div>
            <div class="info-row">
                <label>Prenume:</label>
                <span>{{citizen.prenume}}</span>
            </div>
            <div class="info-row">
                <label>CNP:</label>
                <span>{{citizen.cnp}}</span>
            </div>
            <div class="info-row">
                <label>CI Serie:</label>
                <span>{{citizen.ci_serie}}</span>
            </div>
            <div class="info-row">
                <label>CI Număr:</label>
                <span>{{citizen.ci_numar}}</span>
            </div>
            <div class="info-row">
                <label>Email:</label>
                <span>{{citizen.email}}</span>
            </div>
            <div class="info-row">
                <label>Telefon:</label>
                <span>{{citizen.telefon}}</span>
            </div>
        </div>
    </div>

    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>Close</button>
    </mat-dialog-actions>
</div>